<script setup lang="ts">
import { PropType } from 'vue'

/* Types */
import {
  Cost,
  CostStatuses,
  BasketAddressMessages,
} from '~/types/api/api-v3/basket'

const props = defineProps({
  deliveryCost: {
    required: false,
    default: null,
    type: Object as PropType<Cost>,
  },
  isDeliveryArea: {
    required: true,
    type: Boolean,
  },
  isSelectedAddress: {
    type: Boolean,
    required: true,
  },
})

const messageTag = computed(() => {
  // Формируем теги для адресов проверяя выбранный адрес и его возможность доставки
  if (!props.isDeliveryArea) return BasketAddressMessages.NOT_DELIVERY_AREA
  else if (
    props.isSelectedAddress &&
    props.deliveryCost &&
    props.deliveryCost.message
  )
    return props.deliveryCost.message
  else return null
})

const detectedStyleChip = computed(() => {
  if (!props.isDeliveryArea)
    return [
      {
        'address-tag--outside-delivery': !props.isDeliveryArea,
      },
    ]

  const { status } = props.deliveryCost

  return [
    {
      'address-tag--outside-delivery':
        status === CostStatuses.OUTSIDE_DELIVERY_AREA,
      'address-tag--free-delivery': status === CostStatuses.FREE_DELIVERY,
    },
  ]
})
</script>

<template>
  <div v-if="messageTag" class="address-tag" :class="detectedStyleChip">
    {{ messageTag }}
  </div>
</template>

<style lang="scss" scoped>
.address-tag {
  height: 27px;
  padding: 3px 10px;
  font-size: 12px;
  font-weight: bold;
  color: $white;
  background: $primary;
  border-radius: 20px;

  &--free-delivery {
    background: $basket-success;
  }

  &--outside-delivery {
    background: $text-black;
  }
}
</style>
